// extracted by mini-css-extract-plugin
module.exports = {"menu":"categoryDropdown_menu__D3yr1","input":"categoryDropdown_input__wKCvJ","container":"categoryDropdown_container__DGJ4q"};